import React, { useEffect, useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Spinner from "../Spinner";
import ReactModal from "react-modal";
import {
  ExportIDMtrustExcel,
  IDMTrust_Sorting_API,
  IDMtrust_Edit_API,
  IDMtrust_Filter_API,
  IDMtrust_List_API,
  IDMtrust_Search_API,
} from "../../../actions/auth";
import { useDispatch } from "react-redux";
import swal from "sweetalert";
import Pagination from "react-js-pagination";
import en from "faker/lib/locales/en";

const IDMTrust = () => {
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [listReducer, setListReducer] = useState("");
  const [list, setList] = useState([]);
  const [error, setError] = useState("");
  const [Id, setId] = useState("");
  const [score, setScore] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchData, setSearchData] = useState("");
  const [user, setUser] = useState("");
  const [filterData, setFilterData] = useState("");
  const [default_page, setDefault_page] = useState("");
  const [sortConfig, setSortConfig] = useState("asc");
  const [sortkey, setSortkey] = useState("");
  const dispatch = useDispatch();

  const openEditModal = (item) => {
    //console.log(item, "item...");
    setModalIsOpen(true);
    setEditItem(item);
    setScore(item?.fraud_score || "");
    setId(item?._id || "");
    setUser(item?.firstname);
  };

  const handleScoreChange = (event) => {
    let value = event.target.value.trim();
    if (/^\d*$/.test(value)) {
      const numericValue = Number(value);
      if (numericValue >= 0 && numericValue <= 100) {
        setScore(value);
        setError("");
      } else {
        setError("Score must be between 0 and 100.");
      }
    } else {
      setError("Invalid score. Please enter a number.");
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setError("");
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    if (sortConfig == "asc") {
      setSortConfig("dsc");
    } else {
      setSortConfig("asc");
    }
    if (searchData) {
      setLoadingData(true);
      dispatch(
        IDMtrust_Search_API(
          searchData,
          activePage,
          default_page ? default_page : 10,
          sortkey,
          sortConfig ? sortConfig : "asc"
        )
      ).then((response) => {
        if (response) {
          //console.log(response, "search API");
          setListReducer(response);
          setList(response?.data);
          setLoadingData(false);
        }
      });
    } else if (filterData) {
      dispatch(
        IDMtrust_Filter_API(
          filterData,
          activePage,
          default_page ? default_page : 10,
          sortkey,
          sortConfig
        )
      ).then((response) => {
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoadingData(false); // Stop loading
      });
    } else {
      setLoading(true);
      dispatch(
        IDMtrust_List_API(
          activePage,
          default_page ? default_page : "10",
          sortkey,
          sortConfig ? sortConfig : "asc"
        )
      ).then((response) => {
        //console.log(response, "IDMtrust_List_API");
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoading(false);
      });
    }
  }, [activePage]);

  //console.log(list, "list......");

  const handleSubmit = () => {
    const data = {
      fraud_score: score,
    };
    if (!score) {
      setError("Please enter score.");
      return;
    }
    document.body.classList.add("swal-open-modal");
    swal({
      text: `Are you sure you want to update this user's score? Once updated, the user will gain access to the application`,
      icon: "warning",
      buttons: {
        confirm: {
          text: "OK",
          value: true,
          visible: true,
          className: "",
          closeModal: true,
        },
        cancel: {
          text: "Cancel",
          value: null,
          visible: true,
          className: "",
          closeModal: true,
        },
      },
      dangerMode: true,
    }).then((willConfirm) => {
      document.body.classList.remove("swal-open-modal");
      if (willConfirm) {
        if (score) {
          dispatch(IDMtrust_Edit_API(Id, data)).then(() => {
            setLoadingData(true);
            dispatch(
              IDMtrust_List_API(
                activePage,
                default_page ? default_page : "10",
                sortkey,
                sortConfig
              )
            ).then((response) => {
              if (response) {
                setListReducer(response);
                setList(response?.data);
                swal("", "Score updated successfully", "success");
                setActivePage(1);
              }
              setLoadingData(false);
            });
          });
        }
      }
    });
    closeModal();
  };
  const total = listReducer?.total;

  //search api calll
  const searchList = (e) => {
    const data = e.target.value.trimStart();
    setSearchData(data);
    setActivePage(1);

    if (data) {
      setLoadingData(true);
      dispatch(
        IDMtrust_Search_API(
          data,
          activePage,
          default_page ? default_page : 10,
          sortkey,
          sortConfig ? sortConfig : "asc"
        )
      ).then((response) => {
        setListReducer(response);
        if (response?.length > 0) {
          //console.log(response, "iffff");
          setList(response?.data);
        } else {
          if (data != "") {
            setList(response?.data);
          }
        }
      });
    } else {
      setLoadingData(true);
      dispatch(
        IDMtrust_List_API(
          activePage,
          default_page ? default_page : "10",
          sortkey,
          sortConfig
        )
      ).then((response) => {
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoadingData(false);
      });
    }
    setLoadingData(false);
  };

  const handlePageChange = (pagenumber) => {
    debugger;
    if (pagenumber) {
      setLoadingData(true);
      const pageSize = default_page ? default_page : 10;
      if (filterData && searchData) {
        setLoadingData(true);
        dispatch(
          IDMtrust_Search_API(
            searchData,
            activePage,
            default_page ? default_page : 10,
            sortkey,
            sortConfig ? sortConfig : "asc"
          )
        ).then((response) => {
          if (response) {
            //console.log(response, "search API");
            setListReducer(response);
            setList(response?.data);
          }
          setLoadingData(false);
        });
      } else if (filterData) {
        dispatch(
          IDMtrust_Filter_API(
            filterData,
            pagenumber,
            pageSize,
            sortkey,
            sortConfig
          )
        ).then((response) => {
          if (response) {
            setListReducer(response);
            setList(response?.data);
          }
          setLoadingData(false); // Stop loading
        });
      } else {
        // If no filter is active, call the list API for pagination
        dispatch(
          IDMtrust_List_API(pagenumber, pageSize, sortkey, sortConfig)
        ).then((response) => {
          if (response) {
            setListReducer(response);
            setList(response?.data);
          }
          setLoadingData(false); // Stop loading
        });
      }
      setActivePage(pagenumber); // Update the active page
    }
  };

  const calculateRange = () => {
    const currentPage = activePage;
    const itemsPerPage = default_page ? default_page : 10;
    const startIndex = (currentPage - 1) * itemsPerPage + 1;
    //console.log(total, "My_TOTAL...");
    let endIndex = currentPage * itemsPerPage;
    if (endIndex > total) {
      endIndex = total;
    }
    return `Showing ${startIndex} to ${endIndex} of ${total} entries`;
  };

  // const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'

  // const sortCities = (order) => {
  //   const sortedCities = [...list].sort((a, b) => {
  //     if (a.firstname < b.firstname) return order === "asc" ? -1 : 1;
  //     if (a.firstname > b.firstname) return order === "asc" ? 1 : -1;
  //     if (a.email < b.email) return order === "asc" ? -1 : 1;
  //     if (a.email > b.email) return order === "asc" ? 1 : -1;
  //     if (a.fraud_score < b.fraud_score) return order === "asc" ? -1 : 1;
  //     if (a.fraud_score > b.fraud_score) return order === "asc" ? 1 : -1;
  //     if (a.phone < b.phone) return order === "asc" ? -1 : 1;
  //     if (a.phone > b.phone) return order === "asc" ? 1 : -1;
  //     return 0;
  //   });
  //   setList(sortedCities);
  //   // Update the list state with sorted data
  // };

  // const handleSortChange = () => {
  //   const newOrder = sortOrder === "asc" ? "desc" : "asc";
  //   setSortOrder(newOrder);
  //   sortCities(newOrder);
  // };

  const handleKeyPress = (e) => {
    //console.log(e.key, "e.key");
    if (e.key == "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleSortChange = (key) => {
    //console.log(key, "keyyyyyyyyyyyy");
    setSortkey(key);

    if (sortConfig == "asc") {
      setSortConfig("dsc");
    } else {
      setSortConfig("asc");
    }

    if (searchData) {
      setLoadingData(true);
      dispatch(
        IDMtrust_Search_API(
          searchData,
          activePage,
          default_page ? default_page : 10,
          key,
          sortConfig ? sortConfig : "asc"
        )
      ).then((response) => {
        if (response) {
          //console.log(response, "search API");
          setListReducer(response);
          setList(response?.data);
        }
        setLoadingData(false);
      });
    } else {
      dispatch(
        IDMTrust_Sorting_API(
          activePage,
          default_page ? default_page : "10",
          key,
          sortConfig ? sortConfig : "asc"
        )
      ).then((response) => {
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoadingData(false); // Stop loading
      });
    }
  };
  // sort handle without api
  // let direction = "asc";
  // if (sortConfig.key === key && sortConfig.direction === "asc") {
  //   direction = "desc";
  // }
  // setSortConfig({ key, direction });

  // const sortedList = [...list].sort((a, b) => {
  //   if (key === "city") {
  //     const cityA = a?.radar[0]?.city || "";
  //     const cityB = b?.radar[0]?.city || "";
  //     if (cityA < cityB) return direction === "asc" ? -1 : 1;
  //     if (cityA > cityB) return direction === "asc" ? 1 : -1;
  //     return 0;
  //   } else {
  //     if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
  //     if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
  //     return 0;
  //   }
  // });
  // setList(sortedList);

  const handleClearSearch = () => {
    if (searchData) {
      setSearchData("");
      setLoading(true);
      dispatch(
        IDMtrust_List_API(
          activePage,
          default_page ? default_page : "10",
          sortkey,
          sortConfig
        )
      ).then((response) => {
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoading(false);
      });
    }
  };

  const filter = (e) => {
    //console.log(e.target.value, "filter_Event");
    setLoadingData(true);
    setFilterData(e.target.value);
    setActivePage(1); // Reset to page 1 when changing filter
    if (e.target.value) {
      setSearchData("");
      dispatch(
        IDMtrust_Filter_API(
          e.target.value,
          1,
          default_page ? default_page : 10,
          sortkey,
          sortConfig
        )
      ).then((response) => {
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoadingData(false); // Stop loading
      });
    } else {
      setLoadingData(true);
      dispatch(
        IDMtrust_List_API(
          1,
          default_page ? default_page : 10,
          sortkey,
          sortConfig
        )
      ).then((response) => {
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoadingData(false);
      });
    }
  };

  const handleSearch = () => {
    if (searchData) {
      dispatch(
        IDMtrust_Search_API(
          searchData,
          activePage,
          default_page ? default_page : 10,
          sortkey,
          sortConfig
        )
      ).then((response) => {
        setListReducer(response);
        if (response?.length > 0) {
          //console.log(response, "iffff");
          setList(response?.data);
        } else {
          if (searchData != "") {
            setList(response?.data);
          }
        }
      });
    }
  };

  const filter2 = (e) => {
    const selectedValue = e.target.value;
    setDefault_page(selectedValue);
    setItemsPerPage(selectedValue);
    setActivePage(1); // Reset to the first page
    // setFilterData("");
    // setSearchData("");
    setLoading(true);

    if (filterData) {
      dispatch(
        IDMtrust_Filter_API(
          filterData,
          activePage,
          selectedValue ? selectedValue : 10,
          sortkey,
          sortConfig
        )
      ).then((response) => {
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoading(false); // Stop loading
      });
    } else if (filterData && e.target.value) {
      // setLoadingData(true);
      dispatch(
        IDMtrust_Search_API(
          searchData,
          activePage,
          default_page ? default_page : 10,
          sortkey,
          sortConfig ? sortConfig : "asc"
        )
      ).then((response) => {
        if (response) {
          //console.log(response, "search API");
          setListReducer(response);
          setList(response?.data);
        }
        setLoading(false);
      });
    } else {
      dispatch(
        IDMtrust_List_API(
          1,
          selectedValue ? selectedValue : "10",
          sortkey,
          sortConfig
        )
      ).then((response) => {
        //console.log(response, "IDMtrust_List_API");
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoading(false);
      });
    }
  };

  const ExportExcel = () => {
    dispatch(ExportIDMtrustExcel());
  };

  return (
    <>
      <ReactModal
        isOpen={modalIsOpen}
        style={{
          overlay: {
            background: "rgba(0, 0, 0, .50)",
            zIndex: "999",
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            minWidth: "570px",
            border: "none",
            padding: "0px",
            animation: "pop-up 0.5s forwards",
            overflow: "hidden",
          },
        }}
      >
        <div className="modal-header pb-3">
          <h6 className="modal-title">Edit Score</h6>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>
        <div className="modal-content border-0">
          <div className="modal-body">
            <form>
              <div className="mb-2">
                {" "}
                <label className="text-black fw-bold mb-2">
                  User: {user ? user : ""}
                </label>
              </div>
              <div className="mb-3">
                <label className="text-black fw-bold mb-2">
                  Edit Score
                  <span className="redErrMsg"> *</span>
                </label>
                <input
                  type="text"
                  placeholder="Edit Score"
                  className="form-control"
                  value={score}
                  onChange={handleScoreChange}
                  onKeyDown={handleKeyPress}
                />
                {error && <p className="text-danger">{error}</p>}
              </div>
            </form>
          </div>
        </div>
        <div className="modal-footer pt-3">
          <button type="button" className="btn btn-light" onClick={closeModal}>
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary ms-2"
            onClick={handleSubmit}
          >
            Save Changes
          </button>
        </div>
      </ReactModal>

      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    IDMtrust
                  </h6>
                </div>
                <div className="card-body">
                  <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                    <div className="row mb-2 ">
                      <div className="col-md-7">
                        <div>
                          <input
                            type="text"
                            className="form-control search-input-new"
                            placeholder="Enter user, email, or phone number to search"
                            value={searchData}
                            onChange={searchList}
                          />
                        </div>
                        {searchData.length >= 1 && (
                          <div
                            onClick={handleClearSearch}
                            className="cross-serach-new"
                          >
                            <i className="fa fa-times cursor-pointerr"></i>
                          </div>
                        )}
                      </div>
                      <div className="col-md-2">
                        <button
                          className="btn btn-primary form-control"
                          onClick={handleSearch}
                          // onKeyDown={handleSearch}
                        >
                          Search
                        </button>
                      </div>
                      <div className="col-md-2">
                        <button
                          className="btn btn-primary form-control"
                          onClick={ExportExcel}
                          // disabled={this.state.loaders}
                        >
                          Export
                        </button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-2 mt-2">
                        <select
                          className="form-select w100"
                          id="inlineFormSelectPref"
                          value={filterData}
                          onChange={(e) => filter(e)}
                        >
                          <option value="">All</option>
                          <option value={"verify"}>Eligible</option>
                          <option value={"non-verify"}>Non eligible</option>
                        </select>
                      </div>

                      <div className="col-md-3 mt-2">
                        <select
                          className="form-select w100"
                          id="inlineFormSelectPref"
                          value={default_page}
                          onChange={(e) => filter2(e)}
                        >
                          <option value={""}>Select No of Rows</option>
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                {loading ? (
                  <div className="loader-container">
                    <div className="loaderss"></div>
                  </div>
                ) : (
                  <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                    <table className="table radar-table">
                      <thead>
                        <tr>
                          <th scope="col">No</th>
                          <th scope="col">
                            Phone number
                            <i
                              onClick={() => handleSortChange("phone")}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>
                          </th>
                          <th scope="col">
                            Email Id
                            <i
                              onClick={() => handleSortChange("email")}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>
                          </th>
                          <th scope="col">
                            User
                            <i
                              onClick={() => handleSortChange("firstname")}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>{" "}
                          </th>

                          <th scope="col">
                            Score
                            <i
                              onClick={() => handleSortChange("fraud_score")}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>
                          </th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loadingData ? (
                          <div className="overlay">
                            <div className="loader bg-transparent">
                              <Spinner />
                            </div>
                          </div>
                        ) : (
                          <>
                            {list && list?.length > 0 ? (
                              list?.map((e, index) => (
                                <>
                                  <tr>
                                    <td>
                                      {(activePage - 1) * itemsPerPage +
                                        (index + 1)}
                                    </td>
                                    <td>{e?.phone ? e?.phone : "-"}</td>
                                    <td>{e?.email ? e?.email : "-"}</td>
                                    <td>{e?.firstname}</td>
                                    <td>
                                      {e?.fraud_score ? e?.fraud_score : "-"}
                                    </td>
                                    <td
                                      onClick={() => openEditModal(e)}
                                      className="cursor-pointerr"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={6}>
                                  <h5
                                    style={{ textAlign: "center" }}
                                    className="mt-3"
                                  >
                                    No results found
                                  </h5>
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                      </tbody>
                    </table>

                    {list && list?.length > 0 ? (
                      <div className="d-flex justify-content-between mt-3 align-items-center">
                        <ul className="mt-3 ps-0">
                          <p>{calculateRange()}</p>
                        </ul>
                        <Pagination
                          activePage={activePage}
                          itemsCountPerPage={itemsPerPage}
                          totalItemsCount={total}
                          onChange={
                            total > itemsPerPage ? handlePageChange : null
                          }
                          itemClass="page-item"
                          linkClass={
                            total && total > 0
                              ? "page-link"
                              : "page-link disabled"
                          }
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IDMTrust;
